import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import Toggle from 'react-toggle'
import axios from 'axios'
import Constant from '../../Constant'
class ShopCategoryList extends React.Component {
  state = {
    ShopCategoryList: [],
    isloading: false,
    isEditing: false,
  }
  componentDidMount() {
    this.dashbord()
  }
  dashbord = async () => {
    var that = this
    await axios
      .get(Constant.getAPI() + `/shop-categories/list-shop-categories`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            ShopCategoryList: res.data?.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  handleStatusChange = async (id, isActive) => {
    var that = this
    var data = {
      id: id,
      is_active: isActive,
    }
    await axios
      .put(Constant.getAPI() + '/shop-categories/update-category-status', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Status has been Changed', 'success')
          that.dashbord()
        }
      })
      .catch((err) => {
        that.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  render() {
    const columns = [
      {
        name: 'category_img_url',
        label: 'Image',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (category_img_url) => {
            return (
              <div>
                {category_img_url !== null ? (
                  <div>
                    {category_img_url?.indexOf('.mp4') !== -1 ? (
                      <video
                        width="250"
                        controls
                      >
                        <source
                          src={
                            category_img_url !== undefined && category_img_url !== null && category_img_url !== {}
                              ? Constant.getImage() + category_img_url
                              : './assets/images/icon.png'
                          }
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      <img
                        src={
                          category_img_url !== undefined && category_img_url !== null && category_img_url !== {}
                            ? Constant.getImage() + category_img_url
                            : './assets/images/icon.png'
                        }
                        className="img-fluid img-40"
                        alt="tbl"
                      />
                    )}
                  </div>
                ) : (
                  <img
                    src={
                      category_img_url !== undefined && category_img_url !== null && category_img_url !== {}
                        ? Constant.getImage() + category_img_url
                        : './assets/images/icon.png'
                    }
                    className="img-fluid img-40"
                    alt="tbl"
                  />
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'category_name_en',
        label: 'Category Name: English',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'category_name_ar',
        label: 'Category Name: Arabic',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (is_active, tableMeta) => {
            return (
              <Toggle
                id={tableMeta.rowData[4]}
                checked={is_active === true ? true : false}
                value={is_active}
                onChange={this.handleStatusChange.bind(this, tableMeta.rowData[4], !is_active, 'isActive')}
              />
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                <Link
                  to={`/shop-categories/add/` + id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Shop Category List</h4>
                    </div>
                  </div>
                  <Link
                    to={`/shop-categories/add/`}
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                    data-modal="modal-13"
                  >
                    <i className="icofont icofont-plus m-r-5"></i> Add Shop Category
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Shop Category List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        {this.state?.isloading ? (
                          'loading...'
                        ) : (
                          <MUIDataTable
                            title={`Shop Category List`}
                            className="table-responsive"
                            data={this.state.ShopCategoryList}
                            columns={columns}
                            options={options}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ShopCategoryList
